/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxGamesLibWebRpcContractsResponseError interface.
 */
export function instanceOfFxGamesLibWebRpcContractsResponseError(value) {
    if (!('Code' in value) || value['Code'] === undefined)
        return false;
    if (!('Message' in value) || value['Message'] === undefined)
        return false;
    if (!('RequestId' in value) || value['RequestId'] === undefined)
        return false;
    return true;
}
export function FxGamesLibWebRpcContractsResponseErrorFromJSON(json) {
    return FxGamesLibWebRpcContractsResponseErrorFromJSONTyped(json, false);
}
export function FxGamesLibWebRpcContractsResponseErrorFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'Code': json['Code'],
        'Message': json['Message'],
        'RequestId': json['RequestId'],
    };
}
export function FxGamesLibWebRpcContractsResponseErrorToJSON(json) {
    return FxGamesLibWebRpcContractsResponseErrorToJSONTyped(json, false);
}
export function FxGamesLibWebRpcContractsResponseErrorToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'Code': value['Code'],
        'Message': value['Message'],
        'RequestId': value['RequestId'],
    };
}
//# sourceMappingURL=FxGamesLibWebRpcContractsResponseError.js.map